import { render, staticRenderFns } from "./EmployeeWorkflow.vue?vue&type=template&id=de64a378&scoped=true&"
import script from "./EmployeeWorkflow.vue?vue&type=script&lang=ts&"
export * from "./EmployeeWorkflow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de64a378",
  null
  
)

export default component.exports